import * as monacoEditor from 'monaco-editor';
import { setDiagnosticsOptions } from 'monaco-yaml';
import { useEffect } from 'react';

import { useEditorModel } from 'src/app/graph/explorerPage/hooks/useEditorModel';
import { assertUnreachable } from 'src/lib/assertUnreachable';

export interface SchemaInfo {
  id: string;
  schema: Record<string, unknown>;
  language: 'yaml' | 'json';
}

export const useApplyJSONSchema = ({
  editor,
  schemaInfo,
}: {
  editor: monacoEditor.editor.IStandaloneCodeEditor;
  schemaInfo?: SchemaInfo;
}) => {
  const model = useEditorModel(editor);
  const modelUri = model?.uri;

  useEffect(() => {
    if (schemaInfo && modelUri) {
      const { id, schema, language } = schemaInfo;
      const schemaUri = `inmemory://json-schema/${id}-schema.json`;
      if (language === 'json') {
        const oldSchemas =
          monacoEditor.languages.json.jsonDefaults.diagnosticsOptions.schemas ??
          [];

        monacoEditor.languages.json.jsonDefaults.setDiagnosticsOptions({
          validate: true,
          comments: 'ignore',
          trailingCommas: 'ignore',
          schemas: [
            {
              uri: schemaUri,
              fileMatch: [modelUri.toString(true)],
              schema,
            },
            ...oldSchemas.filter(({ uri }) => uri !== schemaUri),
          ],
        });
      } else if (language === 'yaml') {
        setDiagnosticsOptions({
          hover: true,
          validate: true,
          completion: true,
          format: true,
          schemas: [
            {
              uri: schemaUri,
              fileMatch: [modelUri.toString(true)],
              schema,
            },
          ],
        });
      } else {
        assertUnreachable(language);
      }
    }
  }, [schemaInfo, modelUri]);
};
